import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { USERS_QUERY } from '../graphql/queries'
import { COMMON_FETCH_USERS } from '../redux/action-types'
import { cleanupCommonFetchUsers } from '../redux/actions'
import { apolloService } from '../services'

import useCleanupRedux from './use-cleanup-redux'

const useUsersQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupCommonFetchUsers)

  const { isLoading, error, data, options } = useSelector(
    store => store.common.users,
  )

  const refetch = useCallback(
    () => apolloService.query(USERS_QUERY, {}, dispatch, COMMON_FETCH_USERS),
    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, data, options }
}

export default useUsersQuery
